import React, { Component } from 'react'
import classnames from 'classnames/bind'

import GradientHeaderWithIntro from 'components/shared/GradientHeaderWithIntro'
import IconTitleText from 'components/shared/IconTitleText'

import css from './styles.module.scss'

classnames.bind(css)

export default class TopFeatures extends Component {
  static defaultProps = {
    theme: 'blue',
    layout: 'gradient-right',
  }

  render() {
    const { className, features, ...rest } = this.props

    return (
      <GradientHeaderWithIntro
        className={className}
        headerChildren={() => (
          <>
            {features && (
              <ul className={css.features}>
                {features &&
                  features.map((feature, id) => {
                    return (
                      <li className={css.item} key={id}>
                        <IconTitleText
                          index={id}
                          {...feature}
                        />
                      </li>

                    )
                  })}
              </ul>
            )}
          </>
        )}
        {...rest}
      />
    )
  }
}
